import { getRouterState, RouterStateUrl } from '../registration';
import { createSelector } from '@ngrx/store';
import { RouterReducerState } from '@ngrx/router-store';

// TODO: replace with https://ngrx.io/guide/router-store/selectors if new version can be upgraded

export const getCurrentRouterUrl = createSelector(getRouterState, (routerReducer: RouterReducerState<RouterStateUrl>) => {
    return routerReducer && routerReducer.state ? routerReducer.state.url : null;
});
